module.exports = __webpack_public_path__ + "static/media/counting_singles.c5283815.jpeg";